var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title is-2 has-text-centered"},[_vm._v("We're in the final stretch. Will your class take home the House of Metal Cup?")]),_c('figure',{staticClass:"image is-square"},[_c('img',{attrs:{"src":"https://tehousecup.blob.core.windows.net/images/Hopeful.png"}})])])
}]

export { render, staticRenderFns }